import React from 'react';
import { NotificationContext } from './NotificationContext';

export const useNotification = () => React.useContext(NotificationContext);